module.exports = __webpack_public_path__ + "img/train-stop-top-mask.a923aac6.png";